import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Suppliers = lazy(() => import("@/pages/agent/directory/suppliers/Suppliers/Suppliers"));
const SupplierDetail = lazy(() => import("@/pages/agent/directory/suppliers/SupplierDetail/SupplierDetail"));
const StopoverHotels = lazy(() => import("@/pages/agent/directory/stopover-hotels/StopoverHotels"));
const AgentPartners = lazy(() => import("@/pages/agent/directory/agent-partners/AgentPartners"));
const SupportOffice = lazy(() => import("@/pages/agent/directory/support-office/SupportOffice"));

const Error404 = lazy(() => import("@/pages/Error404"));

const directoryRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "suppliers",
    children: [
      {
        index: true,
        element: <Suppliers />,
      },
      {
        path: ":id",
        element: <SupplierDetail />,
      },
    ],
  },
  {
    path: "agent-partners",
    element: <AgentPartners />,
  },
  {
    path: "support-office",
    element: <SupportOffice />,
  },
  {
    path: "stopover-hotels",
    element: <StopoverHotels />,
  },
];

export default directoryRoutes;
